document.addEventListener('DOMContentLoaded', () => {
  const closeModal = (modal) => {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('wmu-modal-open');
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-wmu-size-open]');
    if (opener) {
      const modal = document.getElementById(opener.getAttribute('aria-controls'));
      if (modal) {
        modal.hidden = false;
        document.body.classList.add('wmu-modal-open');
        modal.querySelector('[data-wmu-size-close]')?.focus();
      }
      return;
    }
    const closer = event.target.closest('[data-wmu-size-close]');
    if (closer) closeModal(closer.closest('.wmu-size-modal'));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeModal(document.querySelector('.wmu-size-modal:not([hidden])'));
  });
});
